import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  label,
  backgroundColor,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  columnStyle,
  barCornerRadius,
  annotationPointOfHistogram,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  datasetHistogram,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  initHistogram,
  yLinear,
  histogramVerticalCrosshairRect,
  tooltipHistogram,
  kdeRegressionLine,
  ecdfRegressionLine,
  pivotTitle,
  pivotAxisStyle,
  dimensionLinkage,
  histogramXLinear,
  brush,
  fontFamilyTheme,
} from '../pipes'

const histogram: VChartSpecPipeline = [
  fontFamilyTheme,
  initHistogram,
  barCornerRadius,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetHistogram,
  progressive,
  histogramXLinear,
  yLinear,
  label,
  brush,
  tooltipHistogram,
  colorAdapter(discreteLegend, colorLegend),
  histogramVerticalCrosshairRect,
  colorBarStyleFill(columnStyle),
  annotationPointOfHistogram,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  kdeRegressionLine,
  ecdfRegressionLine,
]

const pivotHistogram: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initHistogram,
    barCornerRadius,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetHistogram,
    progressive,
    histogramXLinear,
    pivotAxisStyle(yLinear),
    brush,
    label,
    tooltipHistogram,
    colorBarStyleFill(columnStyle),
    histogramVerticalCrosshairRect,
    annotationPointOfHistogram,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,
    kdeRegressionLine,
    ecdfRegressionLine,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const histogramSpecPipeline = [pivotAdapter(histogram, pivotHistogram)]
